// extracted by mini-css-extract-plugin
export default {"TabNav":"CodeDropdownButton-module__TabNav--zWa9N","NavItem":"CodeDropdownButton-module__NavItem--_hXZP"};